import { cnv_pixel, ym, rstat, rstat4 } from '../../utils/temp-empty-metrics';

import { NavLink } from 'react-router-dom';

import './Header.css';
import logo from "../../assets/img/logo.svg";

export const Header = () => {
	const activeLink = 'menu__link active';
	const normalLink = 'menu__link';

	return (
		<header className="header" >
			<div className="header__flex container">

				<div className="header__logo logo">
					<NavLink to="/" className="logo__link">
						<img src={ logo } alt="Лого сайта mbcash" className="logo__img" width="265" height="45" />
					</NavLink>
				</div>

				{/* <?php $lang="en"; include $_SERVER['DOCUMENT_ROOT'] . '/include/header-lang.php'; ?> */}

				<a
					href="#order"
					onClick={() => {
						ym(95071208,'reachGoal','kassir-1');
						ym(95071208,'reachGoal','kassir-sum');
						rstat('event', 'becomeCashier_btn_click', { 'text': 'Become cashier', 'cls': 'sample element click', 'href': '/index.php#order', 'position': '1',});
						rstat4('event', 'becomeCashier_btn_click', { 'text': 'Become cashier', 'cls': 'sample element click', 'href': '/index.php#order', 'position': '1',}); rstat('event', 'kassir-sum');
					}}
					className="header__send-btn btn-orange btn"
				>Become Cashier</a>

				<div className="header__menu menu">
					<div className="menu__burger burger">
						<button type="button" className="burger__btn _js-burger-btn" aria-label="button open menu"> <span></span> </button>
					</div>
					<nav className="menu__body" data-da=".header__flex,1200,last">
						<ul className="menu__list">
							<li className="menu__item"><NavLink to="/" className={({isActive}) => isActive ? activeLink : normalLink }>Mostbet Cashier</NavLink></li>
							<li className="menu__item"><NavLink to="/registration" className={({isActive}) => isActive ? activeLink : normalLink }>Registration</NavLink></li>
							<li className="menu__item"><NavLink to="/app" className={({isActive}) => isActive ? activeLink : normalLink }>Mobcash App</NavLink></li>
							<li className="menu__item"><NavLink to="/faq" className={({isActive}) => isActive ? activeLink : normalLink }>FAQ</NavLink></li>
							<li className="menu__item"><NavLink to="/contacts" className={({isActive}) => isActive ? activeLink : normalLink }>Contact Us</NavLink></li>
							<li className="menu__item">
								<a
									href="https://mbc-agent.com/mbc.apk"
									onClick={() => {
										cnv_pixel();
										ym(95071208,'reachGoal','kassir-1');
										ym(95071208,'reachGoal','dl-apk1');
										ym(95071208,'reachGoal','dl-link-sum');
										rstat('event', 'downloadAPK_btn_click', { 'text': 'Download APK', 'cls': 'sample element click', 'href': '/1.6.0.apk', 'position': '1',});
										rstat4('event', 'downloadAPK_btn_click', { 'text': 'Download APK', 'cls': 'sample element click', 'href': '/1.6.0.apk', 'position': '1',});
										rstat('event', 'dl-link-sum');
									}}
									target="_blank"
									rel="noreferrer"
									className="menu__link menu__link-download"
								>Download APK</a>
							</li>
						</ul>
					</nav>
				</div>

			</div>
		</header>
	)
}
